import React from "react";
import { FormattedMessage } from "react-intl";
import { RaangeLabel } from "src/shared/components/RaangeLabel";

export const DashboardLabel = () => (
  <RaangeLabel fa="home">
    <FormattedMessage id="dashboard" />
  </RaangeLabel>
);
